import SparklineChart from './SparklineChart';
import { formatLargeNumber, formatPrice } from "../utils/formatUtils";
import ChangeIndicator from "./ChangeIndicator";

export default function TableRowDetails({ detail, marketCap, volume, onMobileTrade }) {
  return (
    <tr className="lg:hidden">
      <td colSpan={6} className="text-sm border-b space-y-6 py-6">

        <div className="grid grid-cols-3">
          <div className="flex flex-col p-2">
            <span className="font-semibold mb-1">24h High</span>
            <span>{formatPrice(Number(detail.high_24h))}</span>
          </div>

          <div className="flex flex-col p-2">
            <span className="font-semibold mb-1">24h Low</span>
            <span>{formatPrice(Number(detail.low_24h))}</span>
          </div>

          <div className="flex flex-col p-2">
            <span className="font-semibold mb-1">All-Time High</span>
            <span>{formatPrice(Number(detail.ath))}</span>
          </div>

          <div className="flex flex-col p-2">
            <span className="font-semibold mb-1">Market Cap</span>
            <span>{formatLargeNumber(Number(marketCap))}</span>
          </div>

          <div className="flex flex-col p-2">
            <span className="font-semibold mb-1">24h Volume</span>
            <span>{formatLargeNumber(Number(volume))}</span>
          </div>

          <div className="flex flex-col p-2">
            <span className="font-semibold mb-1">In Circulation</span>
            <span>{formatLargeNumber(Number(detail.circulating_supply))}</span>
          </div>

        </div>
        <SparklineChart data={detail.sparkline_in_7d}/>

        <div className="flex justify-evenly text-center">
          {["24h", "7d", "30d", "1y"].map((label, idx) => {
            const value = [detail.price_change_percentage_24h, detail.price_change_percentage_7d, detail.price_change_percentage_30d, detail.price_change_percentage_1y][idx];
            return (
              <div className="flex flex-col p-2" key={label}>
                <span className="font-semibold mb-1">{label}</span>
                <ChangeIndicator value={value} />
              </div>
            );
          })}
        </div>

        <button onClick={onMobileTrade} className="w-full bg-blue-500 text-white text-base font-bold rounded-full py-3">Trade</button>
      </td>
    </tr>
  );
}